Application.CustomRadio = {
    ui: {
        container: '.js-radio',
        input: '.js-radio input[type="radio"]',
    },
    ready: function () {

        var self = this;

        if (!$(this.ui.container).length){
            return;
        }

        $(document).on('change', this.ui.input, function(){
            self.update(this);
        });
        $(this.ui.input).each(function(){
            self.update(this);
        });

    },
    update: function(input){

        // deactivate all radios
        var $allRadios = $('input[type="radio"]').filter('[name="' + $(input).attr('name') + '"]');
        var $allContainers = $allRadios.closest(this.ui.container);
        $allContainers.removeClass('active');

        // activate the checked ones
        var $activeContainers = $allContainers.find('input:checked').closest(this.ui.container);
        $activeContainers.addClass('active');

    }
};